/**
 * Module dependencies.
 */

import { ReactElement, useMemo } from 'react';
import {
  availableFiltersKeys,
  orderedFilters
} from 'src/core/content-config/model-ranges';

import { getKeyFromObject } from 'src/core/utils/objects';
import BaseSortSidebar from 'src/components/filters/sort/sort-sidebar';
import SortDisclosure from 'src/components/filters/sort/sort-disclosure';
import groupBy from 'lodash/groupBy';
import map from 'lodash/map';

/**
 * `Props` type.
 */

type Props = {
  availableFilters: any;
  isOpen: boolean;
  isUpdating: boolean;
  onClose: () => void;
  onUpdate: () => void;
};

/**
 * `SortSidebar` component.
 */

const SortSidebar = (props: Props): ReactElement => {
  const { availableFilters, isOpen, isUpdating, onClose, onUpdate } = props;
  const normalizedFilters = useMemo(() => {
    const normalizedFilters = [];
    const groupedFilters = groupBy(availableFilters, 'filterType');

    map(Object.keys(groupedFilters), key => {
      const normalizedKey = getKeyFromObject(availableFiltersKeys, key);

      normalizedFilters[normalizedKey] = {
        ascending: 'asc',
        descending: 'desc'
      };
    });

    return normalizedFilters;
  }, [availableFilters]);

  return (
    <BaseSortSidebar
      isOpen={isOpen}
      isUpdating={isUpdating}
      onClose={onClose}
      onUpdate={onUpdate}
    >
      {map(orderedFilters, filterName => {
        return normalizedFilters[filterName] ? (
          <SortDisclosure
            filterName={filterName}
            key={filterName}
          />
        ) : null;
      })}
    </BaseSortSidebar>
  );
};

/**
 * Export `SortSidebar` component.
 */

export default SortSidebar;
